import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import Grid from '@material-ui/core/Grid';

import { Button, CustomAutocomplete, DatePicker } from 'components';
import { Field, Form, Formik } from 'formik';
import { PageTitle } from 'pages/Layout/PageTitle';
import { providersService } from 'services';
import XLSX from 'xlsx';

export const BorWithoutPN = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [dataModels, setDataModels] = useState([{ label: '', value: '' }]);

  const getModelsBOR = useCallback(async () => {
    try {
      const { data } = await providersService.getModels();

      const allModels = [{ label: 'TODOS', value: '0' }, ...data];
      setDataModels(allModels);
    } catch (error) {
      console.log('erro: ', error.message);
    }
  }, []);

  useEffect(() => {
    getModelsBOR();
  }, [getModelsBOR]);

  const handleDownloadReport = async (values) => {
    setIsLoading(true);
    toast.info('Aguarde um momento, Relatório está sendo gerado');
    try {
      const { data } = await providersService.getBorWithoutPN({
        input_data: values.input_data,
        output_data: values.output_data,
        type_models: values.type_models.value,
      });

      if (data.length > 0) {
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = {
          Sheets: { BorWithoutPN: worksheet },
          SheetNames: ['BorWithoutPN'],
        };

        const now = new Date().toLocaleDateString('pt-BR').split('/').reverse().join('-');
        XLSX.writeFile(workbook, `Relatorio_BOR_sem_PN_${now}.xlsx`);
        toast.success('Relatório gerado com sucesso!');
      } else {
        toast.error('Não há dados para esse relatório.');
      }
    } catch (error) {
      console.log('erro: ', error.message);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <PageTitle>Peças X Modelo (BOR sem PN)</PageTitle>

      <Formik
        initialValues={{
          input_data: new Date(),
          output_data: new Date(),
          type_models: '',
        }}
        onSubmit={handleDownloadReport}
      >
        <Form>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={2}>
              <Field
                size='small'
                disabled={isLoading}
                name='type_models'
                label='Tipo de modelo'
                options={dataModels}
                variant='outlined'
                component={CustomAutocomplete}
              />
            </Grid>
            <Grid item xs={12} lg={2}>
              <Field
                size='small'
                disabled={isLoading}
                name='input_data'
                variant='inline'
                fullWidth
                inputVariant='outlined'
                label='Data inicial'
                component={DatePicker}
              />
            </Grid>
            <Grid item xs={12} lg={2}>
              <Field
                size='small'
                disabled={isLoading}
                name='output_data'
                variant='inline'
                fullWidth
                inputVariant='outlined'
                label='Data final'
                component={DatePicker}
              />
            </Grid>
            <Grid item xs={12} lg={2}>
              <Button type='submit' fullWidth loading={isLoading}>
                Exportar relatório
              </Button>
            </Grid>
          </Grid>
        </Form>
      </Formik>
    </>
  );
};
